import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ELYPTEK_ORG = {
  '@type': 'Organization',
  '@id': 'https://elyptek.com/#organization',
  name: 'Elyptek',
  url: 'https://elyptek.com',
  description: 'Web design and development agency',
};

const SITE_CREDITS_SCHEMA = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': 'https://damascusgin.com/#website',
      name: 'Damascus Gin',
      url: 'https://damascusgin.com',
      description:
        'Official website of Damascus Gin — handcrafted small-batch gin inspired by Syria and Lebanon.',
      author: { '@id': 'https://elyptek.com/#organization' },
      creator: { '@id': 'https://elyptek.com/#organization' },
      publisher: {
        '@type': 'Organization',
        name: 'Damascus Gin',
        url: 'https://damascusgin.com',
      },
    },
    ELYPTEK_ORG,
  ],
};

function SiteCreditsSchema() {
  const location = useLocation();

  useEffect(() => {
    const pageUrl = `https://damascusgin.com${location.pathname}`;
    const schema = {
      ...SITE_CREDITS_SCHEMA,
      '@graph': [
        ...SITE_CREDITS_SCHEMA['@graph'],
        {
          '@type': 'WebPage',
          '@id': `${pageUrl}#webpage`,
          url: pageUrl,
          name: 'Damascus Gin',
          isPartOf: { '@id': 'https://damascusgin.com/#website' },
          author: { '@id': 'https://elyptek.com/#organization' },
          creator: { '@id': 'https://elyptek.com/#organization' },
        },
      ],
    };

    const scriptId = 'site-credits-schema';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schema);
  }, [location.pathname]);

  return null;
}

export default SiteCreditsSchema;
